import styled from 'styled-components';
import { shade } from 'polished';

export const StyledBatchInfosLocationsTable = styled.div`
  display: flex;
  width: 100%;
  padding: 2rem;
  background: ${(props) => shade(0.1, props.theme.colors.white)};
`;
